<template>
    <div class="mfa-email-validation-container">
        <div class="w-53 mfa-section-email-validation">
            <div class="flex mb-12 items-center">
                <div class="w-1/4">
                    <slot name="svg"></slot>
                </div>
                <div class="w-3/4 px-3">
                    <slot name="header"></slot>
                    <slot name="subtitle"></slot>
                </div>
            </div>
            <div class="flex mb-2">
                <div class="w-full">
                    <slot name="form">
                    </slot>
                    <slot name="submitButtons">
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Vue} from "vue-property-decorator";
    import swal from "sweetalert2";
    import axios from "axios";

    export default {
        name: "Mfa",
        data() {
            return {

            }
        },
        methods: {

        }

    }
</script>

<style lang="scss" scoped>
    @import "./mfa.scss";
</style>